import Vue from 'vue'
import App from '@/App.vue'
import vuetify from '@/plugins/vuetify'
import '@/filters'
import '@/plugins/compositionApi'
import '@/plugins/http'
import '@/plugins/localStorage'
import '@/plugins/mask'
import router from '@/router'
import {askAcquiring} from '@/composables/acquiring'
import {askUser} from '@/composables/user'
import {appStates, isSharedState} from '@/constants'
import {getVKClientVersion} from '@/services/vkApi'

Vue.config.productionTip = false

new Vue({
  vuetify,
  router,
  render: h => h(App),
  created () {
    askAcquiring().finally(() => this.getUser())
     // yandex metrika clientVersion ping
    getVKClientVersion().then(({platform, version, build, install_referrer}) => {
      const clientVersion = `${version}${this.$API.OPENED_FROM_FS ? '_ODR' : ''}`
      window.ym(41362719, 'params', {[platform]: {[clientVersion]: {[build]: install_referrer}}})
    })
  },
  mounted() {
    this.$client.interceptors.response.use(
      response => {
        return Promise.resolve(response)
      }, err => {
        if (err.code === 402){
          this.$router.replace(appStates.needPay.path)
        } else {
          return Promise.reject(err)
        }
      }
    )
  },
  methods: {
    getUser () {
      if (this.$route.path === '/') {
        this._redirectToProductsIfNeeded()
      }
      askUser()
        .then(() => {
          if (this.$route.path === '/') {
            this.$router.replace('sources')
          }
        })
        .catch(() => {
          if (this.$route.path !== '/' && !isSharedState(this.$route.name)) {
            this.$router.replace('/')
          }
        })
    },
    _initEruda () {
      return new Promise(resolve => {
        const script = document.createElement('script')
        script.src = "http://cdn.jsdelivr.net/npm/eruda"
        document.body.appendChild(script)
        script.onload = () => {
          window.eruda.init()
          resolve()
        }
      })
    },
    _redirectToProductsIfNeeded() {
      if (window.location.host === 'tovari-dlya-rukodelaya.site' || window.location.host === 'cherenochek.ru') {
        router.replace({name: appStates.acquiringDemoProducts.name})
      }
    }
  },
  watch: {
    '$route' (to) {
      if (to.fullPath === '/') {
        this._redirectToProductsIfNeeded()
      }
    }
  }
}).$mount('#app')
